import { RevisionBulkActionProps } from 'components/tables/data/revision/types';
import Button from 'components/Button';
import { IconEye } from '@tabler/icons-react';
import { FORM_PAGE_PATH, REVISION_PAGE_PATH } from 'routes/paths';
import { useConfirm } from 'components/modals/message/MessageProvider';
import { getBulkRevisionKindGroup } from 'components/tables/data/revision/actions/bulk/kind-utils';

const MAX_REVISIONS_TO_OPEN = 50;

/**
 * Opens all selected revisions in new tabs.
 */
export default function BulkViewAction({ revisions }: RevisionBulkActionProps) {
  const { confirm } = useConfirm();
  const kindGroup = getBulkRevisionKindGroup(revisions);
  const isDisabled = revisions.length > MAX_REVISIONS_TO_OPEN || kindGroup === 'mixed';

  if (revisions.length === 0) {
    return null;
  }

  /**
   * Opens all selected revisions in new tabs.
   */
  const viewAll = () => {
    revisions.forEach((revision) => {
      const url =
        revision.kind === 'revision'
          ? REVISION_PAGE_PATH.insert({ revisionId: String(revision.revisionId) })
          : FORM_PAGE_PATH.insert({ revisionId: String(revision.revisionId) });
      window.open(url, '_blank');
    });
  };

  /**
   * Shows confirmation dialog before opening all revisions.
   */
  const handleClick = () => {
    if (kindGroup === 'mixed') {
      return;
    }

    const isRevision = revisions[0]?.kind === 'revision';
    const subject =
      revisions.length > 4
        ? isRevision
          ? 'revíznych správ'
          : 'formulárov'
        : isRevision
        ? 'revízne správy'
        : 'formuláre';

    if (revisions.length === 1) {
      viewAll();
    } else {
      confirm({
        title: revisions[0]?.kind === 'revision' ? 'Pozrieť revízne správy' : 'Pozrieť formuláre',
        content: `Naozaj chcete otvoriť ${revisions.length} ${subject}, každú v novej karte prehliadača?`,
        primaryButtonText: 'Otvoriť',
        secondaryButtonText: 'Zrušiť',
        onConfirm: viewAll,
      });
    }
  };

  return (
    <Button
      variant="secondary"
      size="sm"
      leftIcon={<IconEye />}
      onClick={handleClick}
      disabled={isDisabled}
      title={
        kindGroup === 'mixed'
          ? 'Nie je možné otvoriť revízne správy a formuláre naraz'
          : revisions.length > MAX_REVISIONS_TO_OPEN
          ? revisions[0]?.kind === 'revision'
            ? `Môžete otvoriť maximálne ${MAX_REVISIONS_TO_OPEN} revíznych správ naraz`
            : `Môžete otvoriť maximálne ${MAX_REVISIONS_TO_OPEN} formulárov naraz`
          : undefined
      }
    >
      Pozrieť ({revisions.length})
    </Button>
  );
}
